import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { login, loggedValidation } from '../redux/ducks/userDuck';
import { status } from '../utils/constants';


import Container from '../components/Container';
import Header from '../components/Header';
import GridContainer from '../components/GridContainer';
import GridHorizontal from '../components/GridHorizontal';
import GridCell from '../components/GridCell';
import Text from '../components/Text';
import Card from '../components/Card';
import Input from '../components/Input';
import Button from '../components/Button';

function Home({
  login, loggedValidation, errorAuth,
  logged,
}) {
  const history = useHistory();
  const [state, setState] = useState({
    email: {
      value: '',
      error: null,
    },
    password: {
      value: '',
      error: null,
    }
  });

  useEffect(() => {
    loggedValidation();
  }, []);

  useEffect(() => {
    if (logged) history.push('/store')
  }, [logged]);

  const handleChange = (value, name, error) => setState(prevState => ({
    ...prevState, [name]: { value, error },
  }));

  const handleSubmit = () => {
    if (((state.email.value && !state.email.error) && (state.password.value && !state.password.error)))
      login(state.email.value, state.password.value);
  }

  return (
    <Container bgColor="light">
      <Header />
      <GridContainer className="home-screen-grid-container">
        <GridHorizontal paddingTop="large">
          <GridCell>
            <Text level="h2" textColor="highlight">
              Bienvenido a PagaTodo Store
            </Text>
            <Text>
              Descarga las aplicaciones móviles desarolladas por nuestro equipo de ingeniería.
            </Text>
          </GridCell>
        </GridHorizontal>
        <GridHorizontal className="login-grid">
          <Card className="login-card">
            <Text placement="center" level="h3" textColor="highlight">
              Inicia sesión
            </Text>
            <Input
              label="Correo electrónico"
              value={state.email.value}
              onChange={({ target }) => {
                handleChange(target.value, 'email', null)
              }}
            />
            <Input
              label="Contraseña"
              type="password"
              value={state.password.value}
              onChange={({ target }) => {
                handleChange(target.value, 'password', null)
              }}
            />
            <Text textColor="danger" level="paragraph">
              { errorAuth }
            </Text>
            <Button
              onClick={() => handleSubmit()}
              disabled={!((state.email.value && !state.email.error) && (state.password.value && !state.password.error))}
            >
              Entrar
            </Button>
          </Card>
        </GridHorizontal>
      </GridContainer>
    </Container>
  );
}

function mapStateToProps ({ user }) {
  return {
    errorAuth: user.status === status.STATUS_LOGING_ERROR ? user.message : '',
    logged: user.logged,
  }
}

export default connect(
  mapStateToProps, {
    login,
    loggedValidation,
  }
)(Home);
